import CityPageTemplate from "../city-template/CityPageTemplate";
import { frankfortConfig } from "./data";

export default function FrankfortPage() {
  return <CityPageTemplate config={frankfortConfig} />;
}